import React from 'react';

const VenusIcon: React.FC<{ className?: string }> = (props) => (
  <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M 130 18.756 C 223.333 -35.13 340 32.228 340 140 C 340 190.017 313.316 236.235 270 261.244 C 253.793 270.601 236.882 276.303 220 278.771 L 220 320 L 262 320 C 263.657 320 265 321.343 265 323 L 265 355 C 265 356.657 263.657 358 262 358 L 220 358 L 220 397 C 220 398.657 218.657 400 217 400 L 183 400 C 181.343 400 180 398.657 180 397 L 180 358 L 138 358 C 136.343 358 135 356.657 135 355 L 135 323 C 135 321.343 136.343 320 138 320 L 180 320 L 180 278.718 C 115.179 269.12 60 214.117 60 140 C 60 89.983 86.684 43.765 130 18.756 Z M 150 226.603 C 216.667 265.093 300 216.98 300 140 C 300 104.273 280.94 71.261 250 53.397 C 183.333 14.907 100 63.02 100 140 C 100 175.727 119.06 208.739 150 226.603 Z"
      fill="currentColor"
    />
  </svg>
);

export default VenusIcon;
